import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotEqual = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.11035 10.5H3C2.72386 10.5 2.5 10.2761 2.5 10C2.5 9.72386 2.72386 9.5 3 9.5H5.68848L5.11035 10.5ZM13 9.5C13.2761 9.5 13.5 9.72386 13.5 10C13.5 10.2761 13.2761 10.5 13 10.5H7.99902L8.57715 9.5H13ZM7.42285 6.5H3C2.72386 6.5 2.5 6.27614 2.5 6C2.5 5.72386 2.72386 5.5 3 5.5H8.00195L7.42285 6.5ZM13 5.5C13.2761 5.5 13.5 5.72386 13.5 6C13.5 6.27614 13.2761 6.5 13 6.5H10.3115L10.8906 5.5H13Z",
		fill: "#0F1826"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.5889 3.52252L5.41064 12.4775",
		stroke: "black",
		strokeLinecap: "round"
	})]
});
export default SvgNotEqual;
